export default __webpack_public_path__ + "static/media/getting_started.82a57137.jpeg";